import { render } from "./ExperimentDetails.vue?vue&type=template&id=66e9e2b7&scoped=true"
import script from "./ExperimentDetails.vue?vue&type=script&lang=js"
export * from "./ExperimentDetails.vue?vue&type=script&lang=js"

import "./ExperimentDetails.vue?vue&type=style&index=0&id=66e9e2b7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e9e2b7"]])

export default __exports__